import Message from "./Message";
import db from "../firebase";
import { collection as col,limit,onSnapshot, orderBy, query} from "firebase/firestore"; 
import { useState,useEffect, useRef, useContext } from "react";
import { HbrScrollDown } from "../newComponents/Mycustomsvgicons";
import { ChatContext } from "../newComponents2/ChatContextApi";

function Messages (){
    const [message,setMessage] = useState([]);
    const scrollContainerRef = useRef(null);
    const messagesEndRef = useRef(null);
    const [showScrollButton,setShowScrollButton]=useState(false);
    // const [chatWallpaper,setChatWallpaper]=useState(false);
    const {chatWallpaper} = useContext(ChatContext);

    useEffect (() => {
        const collectionref = col(db,'CHAT3');
            const q = query(collectionref,orderBy('timestamp','desc'),limit(100));
            const unsub = onSnapshot (q, (snapshot) => {
                const items = [];
              
                snapshot.forEach((doc) => {
                    items.push(doc.data());
                });
                
                setMessage(items.reverse());
             });
             return unsub;
    },[]);

    useEffect(()=>{
        const handleScroll =()=>{
          const {scrollTop, scrollHeight, clientHeight} = scrollContainerRef.current;
          if (scrollTop + clientHeight >= scrollHeight - 10) {
            setShowScrollButton(false);
          }else{
            setShowScrollButton(true);
          }
        }
        const container = scrollContainerRef.current;
        container.addEventListener('scroll', handleScroll);
        return () => container.removeEventListener('scroll', handleScroll);
      },[]);

      const scrollToBottom = () => {
        if (messagesEndRef.current) {
          messagesEndRef.current.scrollIntoView({ 
            behavior: "smooth",
            block: "nearest"
          });
        }
        setShowScrollButton(false);
      };
   

    return ( 
        <div className="messages-collection" ref={scrollContainerRef} style={{backgroundImage:`url(${chatWallpaper})`}}>
            {message && message.map((m,index)=>(
               <Message
               messages ={m}
               key={index}
               usercode={m.usercode}
               message ={m.message}
               messageID = {m.messageID}
               chatImage = {m.chat_image}
               timestamp={m.timestamp}
               displayName = {m.user_name}
               audioUrl = {m.audio_url}
               web_audio_duration={m.web_audio_duration}
               userEmail = {m.user_email}
               replyTo={m.replyTo}
               chatImageRepliedTo={m.chatImageRepliedTo}
               messageRepliedTo={m.messageRepliedTo}
               />
            ))}

        <div>
          {showScrollButton && (
            <div className="scrolltochatbottom" style={{display: showScrollButton ? 'block' : 'none'}}>
              <HbrScrollDown width={"1.7em"} height={"1.7em"} fillColour={"#000000"} handleClick={scrollToBottom}/>
            </div>
          )}
        </div>

        <div ref={messagesEndRef} style={{width:"100%"}}>
        </div>
           
        </div>
    );
}
export default Messages;